"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgScreenLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "screen_Like_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.903 77.959V57.634c.232-8.11-6.252-14.629-14.556-14.634h-3.235c-3.644 0-6.545 2.912-6.47 6.504v17.073c-.227 6.636-2.78 13.333-7.278 18.699L75 97.064l.042 30.488c.041 8.525 6.965 15.487 15.365 15.446h53.374c7.203.107 13.505-5.239 14.557-12.194 0 0 5.751-22.252 5.661-27.5-.091-5.248 0-4.955 0-12.337 0-7.383-9.144-13.09-16.983-13.008h-29.113z"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M117.903 77.959V57.634c.232-8.11-6.252-14.629-14.556-14.634h-3.235c-3.644 0-6.545 2.912-6.47 6.504v17.073c-.227 6.636-2.78 13.333-7.278 18.699L75 97.064l.042 30.488c.041 8.525 6.965 15.487 15.365 15.446h53.374c7.203.107 13.505-5.239 14.557-12.194 0 0 5.751-22.252 5.661-27.5-.091-5.248 0-4.955 0-12.337 0-7.383-9.144-13.09-16.983-13.008h-29.113z",
    stroke: props.color || "#343741",
    strokeWidth: 10,
    mask: "url(#screen_Like_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "screen_Like_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 143V87H39v56h31z"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M70 143V87H39v56h31z",
    stroke: props.color || "#343741",
    strokeWidth: 10,
    mask: "url(#screen_Like_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 97.5h-18m18 14h-18m13 15h-17",
    stroke: props.color || "#343741",
    strokeWidth: 5
  }));
}

var _default = SvgScreenLike;
exports["default"] = _default;